import {
  ConfirmationCardVariant,
  TicketSubmissionSuccessDetails,
} from "../types";

//* Shared TicketSubmission Mocks
export const mockEmail = "cedric@twilio.com";
export const mockEmailProduct = "prod_email_api";
export const mockFirstName = "Cedric";
export const mockLastName = "Robot";
export const mockPhoneNumber = "+19255555555";
export const mockPriorityLevel = "p3_general_issue";
export const mockSubject = "This is a test subject";
export const mockComment = "This is a test comment";
export const mockUsername = "cedric1337";
export const mockOriginUrl = "twilio.com";

export const mockTicketSubmissionDefaults = {
  emailProduct: mockEmailProduct,
  priorityLevel: mockPriorityLevel,
  subject: mockSubject,
  comment: mockComment,
};

export const mockOneSupportCenterFormData = {
  attachments: [],
  comment: mockComment,
  email: mockEmail,
  priorityLevel: mockPriorityLevel,
  subject: mockSubject,
};

export const mockSuccessDetails: TicketSubmissionSuccessDetails = {
  shouldHideForm: true,
  confirmationProps: {
    title: "Request submitted successfully!",
    variant: ConfirmationCardVariant.success,
    details: {
      hooray: {
        label: "Hooray!",
        value: "We did it! 🎉",
      },
    },
  },
};
